import { render, staticRenderFns } from "./CategoryLinkMapping.vue?vue&type=template&id=d31f3f50&name=category-link-mapping&"
import script from "./CategoryLinkMapping.vue?vue&type=script&lang=js&"
export * from "./CategoryLinkMapping.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLinkMapping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CategoryLinkMapping.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports